import styled from '@emotion/styled'
import { Stack } from '@mui/material'

export const Container = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'hasUser',
})<{ hasUser: boolean }>`
  padding: 16px;
  border-radius: 8px;
  width: 100%;
  background-color: ${({ hasUser }) => (!hasUser ? 'rgba(0, 0, 0, 0.12)' : 'white')};
  position: relative;
`
